import { tr, uiLocale } from "@/i18n/copy";
import { useUiLanguage } from "@/i18n/useUiLanguage";
import { PagedItems } from "@/components/EntityCollection";
import { Star } from "lucide-react";

export function ArtistReviewSummary({ reviews, className = "" }) {
  useUiLanguage();
  const count = Number(reviews?.count || 0);
  return <span className={`inline-flex items-center gap-1 text-xs ${className}`} aria-label={count ? tr("{{rating}} stelle su 5, {{count}} recensioni", {rating: reviews.average, count}) : tr("Nessuna recensione")}>
    <Star className={`h-3.5 w-3.5 ${count ? "fill-sky-400 text-sky-400" : "text-zinc-500"}`} aria-hidden="true" />
    {count ? <><b>{new Intl.NumberFormat(uiLocale(), {minimumFractionDigits:1,maximumFractionDigits:1}).format(Number(reviews.average))}</b><span className="opacity-70">({count})</span></> : <span className="opacity-70">{tr("Nessuna recensione")}</span>}
  </span>;
}

export function ArtistReviewList({ reviews = [] }) {
  useUiLanguage();
  if (!reviews.length) return <p className="text-sm text-muted-foreground">{tr("Ancora nessuna recensione per questo artista.")}</p>;
  return <PagedItems items={reviews} size={5}>{review => <details key={review.id} className="rounded-lg border px-3 py-2 text-sm">
    <summary className="cursor-pointer"><span className="inline-flex flex-wrap items-center gap-2 text-xs"><span className="text-sky-400">★ {review.rating}/5</span>{review.created_at && <time className="text-muted-foreground" dateTime={review.created_at}>{new Date(review.created_at).toLocaleDateString(uiLocale())}</time>}<span className="max-w-[15rem] truncate text-muted-foreground">{review.comment||tr("Nessun commento")}</span></span></summary>
    {review.comment && <p className="mt-2 whitespace-pre-wrap break-words text-sm">{review.comment}</p>}
  </details>}</PagedItems>;
}
